// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"84146253","239":"5137de70","455":"f2c2e36a"}[chunkId] + ".chunk.js";
};